import { useParams, useNavigate } from "react-router-dom";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { CreatePro013Form } from "../create/components/create-pro013-form";
import CreatePro014Form from "../create/components/create-pro014-form";
import CreatePro017Form from "../create/components/create-pro017-form";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";

export function EditCampaign() {
  const { type, code } = useParams<{ type: string; code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    // Validate params
    if (!type || !code) {
      navigate("/planejamento-comercial/gestao-campanhas");
    }
  }, [type, code, navigate]);

  const campaignCode = parseInt(code || "0");
  const campaignType = type?.toUpperCase();

  if (!campaignType || !campaignCode) {
    return null;
  }

  return (
    <PageLayout>
      <PageTitle
        title={`Editar Campanha ${campaignType} #${campaignCode}`}
        description="Edite todos os dados da campanha através do wizard completo"
      />
      <ContentContainer>
        <div className="mb-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/planejamento-comercial/gestao-campanhas")}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar para Listagem
          </Button>
        </div>

        {campaignType === "PRO013" && (
          <div className="space-y-4">
            <CreatePro013Form mode="edit" campaignCode={campaignCode} />
          </div>
        )}

        {campaignType === "PRO014" && (
          <div className="space-y-4">
            <CreatePro014Form mode="edit" campaignCode={campaignCode} />
          </div>
        )}

        {campaignType === "PRO017" && (
          <div className="space-y-4">
            <CreatePro017Form mode="edit" campaignCode={campaignCode} />
          </div>
        )}
      </ContentContainer>
    </PageLayout>
  );
}
